import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import Slidershape2 from "../../assets/images/shapes/slider-1-shape-2.png";
import Bgimg from "../../assets/images/backgrounds/slider-1-1.jpg";
import Bgimg1 from "../../assets/images/shapes/slider-1-shape-1.png";
import Bgimg2 from "../../assets/images/backgrounds/slider-1-2.jpg";
import Bgimg3 from "../../assets/images/backgrounds/slider-1-3.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Homeslider = {
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: false,
};

function Sliderone() {
  return (
    <div>
      <section className="main-slider-one">
        <Slider className="" {...Homeslider} arrows={false}>
          <div className="item" data-dot="<button>1/</button>">
            <div className="main-slider-one__item">
              <div
                className="main-slider-one__bg"
                style={{ backgroundImage: `url(${Bgimg})` }}
              />
              <div className="main-slider-one__overlay" />
              <div
                className="main-slider-one__shape"
                style={{ backgroundImage: `url(${Bgimg1})` }}
              />
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="main-slider-one__content">
                      <div className="main-slider-one__image">
                        <img src={Slidershape2} alt="hiredots" />
                      </div>
                      <h2 className="main-slider-one__title">
                        Empowering
                        <br /> Careers.
                        <br /> Strengthening Businesses.
                      </h2>

                      <div className="main-slider-one__btn">
                        <Link to="/about" className="hiredots-btn">
                          <span>Learn More</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="item" data-dot="<button>2/</button>">
            <div className="main-slider-one__item">
              <div
                className="main-slider-one__bg"
                style={{ backgroundImage: `url(${Bgimg2})` }}
              />
              <div className="main-slider-one__overlay" />
              <div
                className="main-slider-one__shape"
                style={{ backgroundImage: `url(${Bgimg1})` }}
              />
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="main-slider-one__content">
                      <div className="main-slider-one__image">
                        <img src={Slidershape2} alt="hiredots" />
                      </div>
                      <h2 className="main-slider-one__title">
                        Connecting
                        <br /> Right Talent
                        <br /> with Right Opportunities
                      </h2>

                      <div className="main-slider-one__btn">
                        <Link to="/services" className="hiredots-btn">
                          <span>Our Services</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="item" data-dot="<button>3</button>">
            <div className="main-slider-one__item">
              <div
                className="main-slider-one__bg"
                style={{ backgroundImage: `url(${Bgimg3})` }}
              />
              <div className="main-slider-one__overlay" />
              <div
                className="main-slider-one__shape"
                style={{ backgroundImage: `url(${Bgimg1})` }}
              />
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="main-slider-one__content">
                      <div className="main-slider-one__image">
                        <img src={Slidershape2} alt="hiredots" />
                      </div>
                      <h2 className="main-slider-one__title">
                        Career Guidance
                        <br /> Training &
                        <br /> Placement Support
                      </h2>

                      <div className="main-slider-one__btn">
                        <Link to="/contact" className="hiredots-btn">
                          <span>Get Started</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </section>
    </div>
  );
}

export default Sliderone;
